module.exports = __webpack_public_path__ + "media/images/youth_citizens_science/form_diagram_ca-295fbe36852631056c267c3ad2fdc2e7.png";